import { gql } from 'providers/tanstack-query/utils'

export const BUILD_ORDER_FOR_TABLE_FRAGMENT = gql`
  fragment BuildOrderForTableFragment on BuildOrder {
    buildOrderRequester {
      firstName
      lastName
    }
    changes
    configurationUrl
    domain {
      name
    }
    id
    status
    updatedAt
  }
`
